import HttpCliente from "../HttpCliente";

export const getOrganizaciones = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Organizacion/ObtenerOrganizaciones", {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const postOrganizacion = (token, organizacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Organizacion/CrearOrganizacion", organizacion, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const putOrganizacion = (token, organizacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Organizacion/EditarOrganizacion", organizacion, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const deleteOrganizacion = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/Organizacion/EliminarOrganizacion/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};